export default (oItem) => {
    oItem = oItem.target ?? oItem;
    const oCard = oItem.closest('.card');

    if (!oCard) {
        return;
    }

    oCard.setAttribute('data-show-card-add', '');
    document.querySelector('html').setAttribute('data-show-qv', '');
}
